export { default } from './media-carousel';
export type { MediaCarouselProps, LocalizedHref } from './interfaces';
